module.exports = __webpack_public_path__ + "img/fb_meta.cef77f2e.png";